import { injectIntl, intlShape } from "@edx/frontend-platform/i18n";
import messages from "../messages";
import RecentActivity from "./RecentActivity";
import UpcomingEvents from "./UpcomingEvents";

const Updates = ({ intl }) => {
  return (
    <div className="updates-container">
      <div className="updates__header">
        <div className="updates__title">{intl.formatMessage(messages.updatesTitle)}</div>
      </div>
      <div className="updates">
        <RecentActivity />
        <UpcomingEvents />
      </div>
    </div>
  );
}

Updates.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Updates);